import './lancamentos.css';
import React, { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import TopoIcone from "./TopoIcone";
import { Truck, Warehouse, ScanBarcode, CornerDownLeft, SearchCheck, Save, X as IconX, Trash2, ChevronLeft } from "lucide-react";
import axios from "axios";
import QuaggaScanner from "./QuaggaScanner";
import tratarCodigoLido from "./FUNCTratarCodigoLido";



function Devolucao() {
  const navigate = useNavigate();
  const location = useLocation();
  const usuarioLogado = location.state?.usuario || localStorage.getItem("nomeUsuario") || "USUÁRIO DESCONHECIDO";


  const [data, setData] = useState(new Date().toISOString().slice(0, 10));
  const [clienteSelecionado, setClienteSelecionado] = useState(null);
  const [codigoCliente, setCodigoCliente] = useState("");
  const [carrinhoCodigo, setCarrinhoCodigo] = useState("");
  const [carrinhos, setCarrinhos] = useState([]);
  const [foco, setFoco] = useState("");
  const [alertaCarrinho, setAlertaCarrinho] = useState(false);
  const [alertaDevolucao, setAlertaDevolucao] = useState(false);
  const [rotaDestino, setRotaDestino] = useState("");
  const [alertaCarrinhoDesconhecido, setAlertaCarrinhoDesconhecido] = useState(false);
  const [mensagemSucesso, setMensagemSucesso] = useState(false);

  const formatarData = (valor) => {
    if (!valor) return '';
    const [ano, mes, dia] = valor.split('-');
    return `${dia}/${mes}/${ano}`;
  };

  // PARTE SCANNER
  const podeLerRef = useRef(true); // começa podendo ler
  const quaggaRef = useRef(null);  // onde vamos guardar o Quagga para controle
  const [codigoLidoDesconhecido, setCodigoLidoDesconhecido] = useState("");

  const [scannerAberto, setScannerAberto] = useState(false);
  const [mensagemScanner, setMensagemScanner] = useState(false);








  useEffect(() => {
    setCodigoCliente("265");
    setClienteSelecionado({ idt: 265, nome_fantasia: "COOPERATIVA VEILING HOLAMBRA" });
  }, [])



  const limparFormulario = () => {
    setData(new Date().toISOString().slice(0, 10));
    setCarrinhoCodigo("");
    setCarrinhos([]);
  };



  const adicionarCarrinho = async () => {
    const corrigido = carrinhoCodigo
  .normalize("NFD")
  .replace(/\p{Diacritic}/gu, "")
  .trim()
  .toUpperCase()
  .replace(/^CAR0+(\d+)$/, "CAR$1")
  .replace(/^B0+(\d+)$/, "B$1");



    if (!corrigido) {
      console.log("Carrinho vazio.");
      return;
    }

    if (carrinhos.find(c => c.codigo === corrigido)) {
      console.log("Carrinho duplicado.");
      setAlertaCarrinho(true);
      return;
    }

    try {
      const valida = await axios.get(`${process.env.REACT_APP_API}/verificar-carrinho?codigo=${corrigido}`);

      if (!valida.data.valido) {

        podeLerRef.current = false;               // bloqueia leitura

        setAlertaCarrinhoDesconhecido(true);     // mostra o alerta (deixa o scanner aberto)

        return;
      }

      const resposta = await axios.get(`${process.env.REACT_APP_API}/tempo-posse?codigo=${corrigido}`);
      const tempoPosse = resposta.data.tempo_posse ?? null;


      setCarrinhos((prev) => {
        const todos = [...prev, { codigo: corrigido, tempo_posse: tempoPosse }];
        const unicos = [];

        const codigosVistos = new Set();

        for (const item of todos) {
          if (!codigosVistos.has(item.codigo)) {
            codigosVistos.add(item.codigo);
            unicos.push(item);
          }
        }

        return unicos;
      });

      setCarrinhoCodigo("");

    } catch (error) {
      console.error("Erro ao adicionar carrinho:", error);
    }
  };

  const removerCarrinho = (index) => {
    const novosCarrinhos = carrinhos.filter((_, i) => i !== index);
    setCarrinhos(novosCarrinhos);
  };

  const confirmarTrocaDeTela = (rota) => {
    if (carrinhos.length > 0) {
      setRotaDestino(rota);
      setAlertaDevolucao(true);
    } else {
      navigate(rota);
    }
  };

  const salvarDevolucao = async () => {
    try {
      // ✅ Pega o token salvo na sessão (após login)
      const token = sessionStorage.getItem("token");

      const res = await axios.post(
        `${process.env.REACT_APP_API}/salvar-devolucao`,
        {
          data,
          codigoCliente,
          carrinhos,
          usuario: usuarioLogado
        },
        {
          headers: {
            Authorization: `Bearer ${token}` // ✅ Envia o token JWT no cabeçalho
          }
        }
      );

      if (res.data.sucesso) {
        setMensagemSucesso(true);
        setTimeout(() => {
          setMensagemSucesso(false);
          limparFormulario();
        }, 2500);
      } else {
        alert("Erro ao salvar devolução.");
      }
    } catch (err) {
      console.error("❌ Erro na gravação:", err);
      alert("Erro ao salvar devolução.");
    }
  };




  const ClearIcon = ({ onClick }) => (
    <span
      onMouseDown={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onClick();
      }}
      style={{
        position: "absolute",
        right: "90px",
        top: "35%",
        transform: "translateY(-50%)",
        cursor: "pointer",
        zIndex: 10,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "transparent",
        padding: "0 2px"
      }}
    >
      <IconX size={14} color="#888" />
    </span>
  );

  return (
    <div className="lancamento-container">
      {mensagemSucesso && (
        <div style={{
          position: 'fixed',
          top: '1rem',
          left: '50%',
          transform: 'translateX(-50%)',
          backgroundColor: '#e6f9ec',
          color: '#10693e',
          padding: '0.75rem 1.25rem',
          borderRadius: '8px',
          boxShadow: '0 2px 10px rgba(0,0,0,0.15)',
          zIndex: 10000,
          display: 'flex',
          alignItems: 'center',
          gap: '0.5rem',
          fontWeight: 400,
          fontSize: '0.95rem',
          whiteSpace: 'nowrap'
        }}>
          <span style={{ fontSize: '1.25rem' }}>✅</span>
          Devoluções registradas com sucesso!
        </div>
      )}

      <div className="lancamento-dark-header">
        <TopoIcone icone={<CornerDownLeft size={20} color="#00664F" />} />

        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start', // 👈 garante alinhamento à esquerda
            width: '100%',                // 👈 ocupa toda a largura disponível
            gap: '0.5rem',
            padding: '0 1rem',
            height: '40px'
          }}
        >

          <div
            onClick={() => confirmarTrocaDeTela("/menu")}
            style={{ cursor: 'pointer', display: 'flex', alignItems: 'center' }}
          >


            <ChevronLeft size={24} color="white" strokeWidth={2} />
          </div>
          <span style={{ color: 'white', fontSize: '1.1rem', fontWeight: 'bold' }}>
            Devoluções
          </span>
        </div>
      </div>

      <div className="lancamento-content">
        <div className="lancamento-ficha">
          <div style={{ width: "100%", overflow: "hidden", marginBottom: "0rem" }}>

            <div style={{ position: "relative", width: "100%" }}>
              <label className="lancamento-label">Data</label>
              <input
                type="text"
                className="lancamento-input"
                value={formatarData(data)}
                readOnly
                onClick={() => document.getElementById("inputDataReal").showPicker?.()} // dispara o calendário nativo
                style={{
                  width: "100%",
                  boxSizing: "border-box",
                  color: "#000",
                  backgroundColor: "#f0faf7",
                  cursor: "pointer"
                }}
              />
              <input
                id="inputDataReal"
                type="date"
                value={data}
                onChange={(e) => setData(e.target.value)}
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  opacity: 0,
                  cursor: "pointer"
                }}
              />
            </div>

          </div>

          <div style={{ display: "flex", gap: "0.5rem", marginBottom: "1rem", alignItems: "flex-end" }}>
            <div style={{ flex: "0 0 70px", position: "relative" }}>
              <label className="lancamento-label">Destino</label>
              <input
                type="text"
                className="lancamento-input"
                value="265"
                readOnly
                disabled
              />
            </div>
            <div style={{ flex: 2, position: "relative" }}>
              <label className="lancamento-label" style={{ visibility: "hidden" }}>.</label>
              <input
                type="text"
                className="lancamento-input"
                value="COOPERATIVA VEILING HOLAMBRA"
                readOnly
                disabled
              />
            </div>
          </div>

          <div className="lancamento-carrinho-wrapper">
            <label className="lancamento-label">Adicionar Carrinhos</label>
            <div className="lancamento-add-carrinho" style={{ position: "relative", marginBottom: "0rem" }}>
              <input
                type="text"
                value={carrinhoCodigo}
                onFocus={() => setFoco("carrinho")}
                onBlur={() => setFoco("")}
                onChange={(e) => setCarrinhoCodigo(e.target.value)}
                onKeyDown={async (e) => {
                  if (e.key === 'Enter') {
                    e.preventDefault();
                    await adicionarCarrinho();
                  }
                }}
                autoComplete="off"
                autoCorrect="off"
                spellCheck="false"
                inputMode="text"
                translate="no"
              />


              {foco === "carrinho" && carrinhoCodigo && (
                <ClearIcon onClick={() => setCarrinhoCodigo("")} />
              )}

              <button onClick={async () => await adicionarCarrinho()} className="lancamento-add-button">+</button>
              {/* PARTE SCANNER */}
              <button
                onClick={() => {
                  setScannerAberto(true);
                }}
                className="lancamento-add-button"
                style={{
                  marginLeft: "0rem",
                  width: "45px",
                  height: "36px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: 0
                }}
              >
                <ScanBarcode size={20} color="white" />
              </button>

            </div>
          </div>

          <div style={{ display: 'flex', alignItems: 'center', marginTop: '0.10rem', marginBottom: '0.25rem' }}>
            <div style={{ flex: 1, height: '1px', backgroundColor: '#ccc' }}></div>
            <span style={{ padding: '0 0.75rem', fontWeight: 'bold', fontSize: '0.95rem', color: '#333' }}>Lançados</span>
            <div style={{ flex: 1, height: '1px', backgroundColor: '#ccc' }}></div>
          </div>

          <div style={{
            border: '1px solid #ccc',
            borderRadius: '8px',
            padding: '0.5rem',
            marginBottom: '1rem',
            backgroundColor: '#fff',
            boxShadow: '0 2px 6px rgba(0,0,0,0.05)',
            maxHeight: '270px',
            overflowY: 'auto'
          }}>
            {carrinhos.length === 0 ? (
              <div style={{ fontSize: '0.85rem', color: '#777', textAlign: 'center' }}>
                Nenhum carrinho lançado.
              </div>
            ) : (
              <table style={{ width: '100%', fontSize: '0.9rem', borderCollapse: 'collapse' }}>
                <thead>
                  <tr>
                    <th style={{ textAlign: 'left', borderBottom: '1px solid #ccc', paddingBottom: '0.4rem' }}>Código</th>
                    <th
                      style={{
                        textAlign: 'center',
                        borderBottom: '1px solid #ccc',
                        padding: '0.4rem 0.5rem',
                        width: '70px'
                      }}
                      translate="no"
                    >
                      Posse
                    </th>
                    <th style={{ width: '30px' }}></th>
                  </tr>
                </thead>
                <tbody>


                  {Object.values(carrinhos.slice()
                    .reverse()
                    .reduce((acc, item) => {
                      acc[item.codigo] = item; // mantém o último com esse código
                      return acc;
                    }, {})
                  ).map((item, i) => {
                    const isAlerta = item.tempo_posse > 20;
                    const isProprio = !item.tempo_posse || item.propriedade === "PROPRIA";

                    return (
                      <tr
                        key={i}
                        style={{
                          backgroundColor: isAlerta
                            ? "#ffe5e5" // Vermelho claro
                            : isProprio
                              ? "#eaffea" // Verde claro
                              : "transparent"
                        }}
                      >

                        <td style={{ padding: '0.5rem 0', borderBottom: '1px solid #eee' }}>{item.codigo}</td>
                        <td
                          style={{
                            textAlign: 'center',
                            verticalAlign: 'middle',
                            padding: '0.5rem 0.5rem',
                            borderBottom: '1px solid #eee',
                            fontWeight: '500',
                            color: '#333'
                          }}
                          translate="no"
                        >
                          {item.tempo_posse ?? '-'}
                        </td>
                        <td style={{ paddingLeft: '0.5rem', borderBottom: '1px solid #eee' }}>
                          <Trash2
                            size={14}
                            color="#b30000"
                            style={{ cursor: 'pointer', opacity: 0.7 }}
                            onClick={() => removerCarrinho(carrinhos.length - 1 - i)}
                          />
                        </td>
                      </tr>
                    );
                  })}

                </tbody>
              </table>

            )}
          </div>

          <div className="lancamento-btn-group">
            <button className="lancamento-btn-cancelar-icon" onClick={limparFormulario} title="Cancelar">
              <IconX size={24} />
            </button>
            <div style={{ flex: 1, margin: "0 0.5rem" }}>
              <label className="lancamento-label" style={{ textAlign: "center", display: "block" }}>
                Quantidade
              </label>
              <input
                type="text"
                className="lancamento-input"
                value={carrinhos.length}
                readOnly
                style={{ textAlign: "center", height: "50px", fontSize: "2rem" }}
              />
            </div>
            <button
              className="lancamento-btn-salvar-icon"
              disabled={!clienteSelecionado || carrinhos.length === 0}
              title="Salvar"
              onClick={salvarDevolucao}
            >
              <Save size={24} />
            </button>

          </div>
        </div>
      </div>


      <div className="lancamento-footer-group">
        <div className="lancamento-shortcuts">
          <div className="menu-shortcut" onClick={() => confirmarTrocaDeTela("/saida")}> <Truck size={20} color="#00996D" /><span>Saída</span></div>
          <div className="lancamento-shortcut" onClick={() => confirmarTrocaDeTela("/estoque")}> <Warehouse size={20} color="#00996D" /><span>Estoque</span></div>
          <div className="lancamento-shortcut active" onClick={() => confirmarTrocaDeTela("/devolucao")}> <CornerDownLeft size={20} color="#DB0B0E" /><span>Devolução</span></div>
          <div className="lancamento-shortcut" onClick={() => confirmarTrocaDeTela("/decisao")}> <SearchCheck size={20} color="#00996D" /><span>Decidir</span></div>
        </div>
      </div>



      {alertaCarrinho && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          backgroundColor: 'rgba(0,0,0,0.4)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 9999
        }}>
          <div style={{
            backgroundColor: '#fff',
            padding: '2rem',
            borderRadius: '12px',
            boxShadow: '0 2px 10px rgba(0,0,0,0.3)',
            textAlign: 'center',
            maxWidth: '300px',
            width: '80%'
          }}>
            <div style={{ marginBottom: '1rem' }}>
              <div style={{
                fontWeight: 'bold',
                color: '#b30000',
                fontSize: '1.1rem',
                marginBottom: '0.5rem'
              }}>
                ATENÇÃO
              </div>
              <div style={{
                fontSize: '1rem',
                color: '#333'
              }}>
                Carrinho já lançado!
              </div>
            </div>
            <button
              translate="no"
              autoComplete="off"
              autoCorrect="off"
              spellCheck="false"
              onClick={() => {
                setAlertaCarrinho(false);  // <- isso que fecha o alerta
                setCarrinhoCodigo("");     // <- isso limpa o campo, opcional
              }}
              style={{
                padding: '0.3rem 0.8rem',
                border: 'none',
                borderRadius: '6px',
                backgroundColor: '#00996D',
                color: 'white',
                cursor: 'pointer',
                fontSize: '0.85rem'
              }}
            >
              OK
            </button>

          </div>
        </div>
      )}

      {alertaDevolucao && (
        <div style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', backgroundColor: 'rgba(0,0,0,0.4)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 9999 }}>
          <div style={{ backgroundColor: '#fff', padding: '2rem', borderRadius: '12px', boxShadow: '0 2px 10px rgba(0,0,0,0.3)', textAlign: 'center', maxWidth: '320px', width: '85%' }}>
            <div style={{ marginBottom: '1.5rem' }}>
              <div style={{ fontWeight: 'bold', color: '#b30000', fontSize: '1.1rem', marginBottom: '0.5rem' }}>
                ATENÇÃO
              </div>
              <div style={{ fontSize: '1rem', color: '#333' }}>
                Se sair agora você vai perder o lançamento atual, deseja continuar?
              </div>
            </div>
            <div style={{ display: 'flex', justifyContent: 'center', gap: '1rem' }}>
              <button onClick={() => navigate(rotaDestino)} style={{ padding: '0.5rem 1rem', backgroundColor: '#ef4444', border: 'none', borderRadius: '8px', color: 'white', fontWeight: 'bold', cursor: 'pointer' }}>
                SIM
              </button>
              <button onClick={() => setAlertaDevolucao(false)} style={{ padding: '0.5rem 1rem', backgroundColor: '#00996D', border: 'none', borderRadius: '8px', color: 'white', fontWeight: 'bold', cursor: 'pointer' }}>
                NÃO
              </button>
            </div>
          </div>
        </div>
      )}
      {/* INICIO PARTE SCANNER */}
      {scannerAberto && (
        <QuaggaScanner
          ref={quaggaRef}
          podeLerRef={podeLerRef}
          onDetected={(codigo) => tratarCodigoLido(codigo, {
            carrinhos,
            setCarrinhos,
            setAlertaCarrinho,
            setAlertaCarrinhoDesconhecido,
            setMensagemScanner,
             setCodigoLidoDesconhecido,
            podeLerRef
          })}
          onClose={() => setScannerAberto(false)}
        />
      )}
      {/* FIM PARTE SCANNER */}

      {alertaCarrinho && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          backgroundColor: 'rgba(0,0,0,0.4)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 9999
        }}>
          <div style={{
            backgroundColor: '#fff',
            padding: '2rem',
            borderRadius: '12px',
            boxShadow: '0 2px 10px rgba(0,0,0,0.3)',
            textAlign: 'center',
            maxWidth: '300px',
            width: '80%'
          }}>
            <div style={{ marginBottom: '1rem' }}>
              <div style={{
                fontWeight: 'bold',
                color: '#b30000',
                fontSize: '1.1rem',
                marginBottom: '0.5rem'
              }}>
                ATENÇÃO
              </div>
              <div style={{
                fontSize: '1rem',
                color: '#333'
              }}>
                Carrinho já lançado!
              </div>
            </div>
            <button
              translate="no"
              autoComplete="off"
              autoCorrect="off"
              spellCheck="false"
              onClick={() => {
                setAlertaCarrinho(false);  // <- isso que fecha o alerta
                setCarrinhoCodigo("");     // <- isso limpa o campo, opcional
              }}
              style={{
                padding: '0.3rem 0.8rem',
                border: 'none',
                borderRadius: '6px',
                backgroundColor: '#EF4444',
                color: 'white',
                cursor: 'pointer',
                fontSize: '0.85rem'
              }}
            >
              OK
            </button>

          </div>
        </div>
      )}






      {alertaCarrinhoDesconhecido && (
        <div translate="no" style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100vw',
          height: '100vh',
          backgroundColor: 'rgba(0,0,0,0.4)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 9999
        }}>
          <div style={{
            backgroundColor: '#fff',
            padding: '2rem',
            borderRadius: '12px',
            boxShadow: '0 2px 10px rgba(0,0,0,0.3)',
            textAlign: 'center',
            maxWidth: '300px',
            width: '80%'
          }}>
            <div style={{ marginBottom: '1rem' }}>
              <div style={{
                fontWeight: 'bold',
                color: '#b30000',
                fontSize: '1.1rem',
                marginBottom: '0.5rem'
              }}>
                ATENÇÃO
              </div>
              <div style={{
                fontSize: '1rem',
                color: '#333'
              }}>
                  <strong>{codigoLidoDesconhecido}</strong>, Carrinho não reconhecido.
              </div>
            </div>
            <button

              // PARTE SCANNER
              onClick={() => {
                setAlertaCarrinhoDesconhecido(false);
              }}
              style={{
                padding: '0.3rem 0.8rem',
                border: 'none',
                borderRadius: '6px',
                backgroundColor: '#EF4444',
                color: 'white',
                cursor: 'pointer',
                fontSize: '0.85rem'
              }}
            >
              OK
            </button>
          </div>
        </div>
      )}

      {mensagemScanner && (
        <div style={{
          position: 'fixed',
          top: '1rem',
          left: '50%',
          transform: 'translateX(-50%)',
          backgroundColor: '#e6f9ec',
          color: '#10693e',
          padding: '0.75rem 1.25rem',
          borderRadius: '8px',
          boxShadow: '0 2px 10px rgba(0,0,0,0.15)',
          zIndex: 10000,
          display: 'flex',
          alignItems: 'center',
          gap: '0.5rem',
          fontWeight: 400,
          fontSize: '0.95rem',
          whiteSpace: 'nowrap'
        }}>
          <span style={{ fontSize: '1.25rem' }}>✅</span>
          Carrinho incluído com sucesso!
        </div>
      )}



    </div>

  );
}

export default Devolucao;